// Display name for a service request's service type. When the requester picked
// "Other" and typed their own name, the backend stores it as customServiceType
// while serviceType stays the canonical "Other" (every SR ↔ calendar/timeline
// match keys off serviceType). Use this ONLY for what the user sees — never
// for matching or lookups, which must keep using sr.serviceType.
export const getServiceTypeLabel = (sr) => {
  if (!sr) return '';
  const custom = (sr.customServiceType || '').trim();
  if (custom && (sr.serviceType || '').toLowerCase() === 'other') return custom;
  return sr.serviceType || '';
};
